import { Box, Button } from "@mui/material";
import React from "react";
import styles from "./style.module.css";
import { ChevronLeft } from "@mui/icons-material";
import CreatorType from "./components/creator-type";
import Logo from "./components/logo";
import { useNavigate } from "react-router-dom";
import HWCThanks from "./HWCThanks";
import { useTheme } from "../../../../context/themeContext";
import useProtectedAuth from "../../../../hooks/useProtectedAuth";

const HelpWithClassification = () => {
  useProtectedAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey500,
      }}
    >
      <HWCThanks />
      <Box className={styles.container}>
        <Box className={styles.arrow}>
          <Button
            startIcon={<ChevronLeft />}
            onClick={() => navigate(-1)}
            sx={{
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "500",
              color: theme.palette.darkgrey.darkgrey500,
            }}
          >
            Back
          </Button>
        </Box>
        <Logo />
        <CreatorType />
      </Box>
    </Box>
  );
};

export default HelpWithClassification;
